export default __webpack_public_path__ + "static/media/banner-image.757bc586.svg";